import { createServerFn } from "@tanstack/react-start";
import {
  listArticlesSchema,
  articlePathSchema,
  slugSchema,
  uuidSchema,
} from "./agora-schemas";

export const fetchAgoraArticles = createServerFn({ method: "GET" })
  .inputValidator((data: unknown) => listArticlesSchema.parse(data ?? {}))
  .handler(async ({ data }) => {
    const { listPublishedArticles } = await import("./agora-queries.server");
    return listPublishedArticles(data);
  });

export const fetchAgoraCategories = createServerFn({ method: "GET" }).handler(async () => {
  const { listCategories } = await import("./agora-queries.server");
  return listCategories();
});

export const fetchAgoraCategory = createServerFn({ method: "GET" })
  .inputValidator((data: unknown) => slugSchema.parse(data))
  .handler(async ({ data }) => {
    const { getCategory } = await import("./agora-queries.server");
    return getCategory(data);
  });

export const fetchAgoraArticle = createServerFn({ method: "GET" })
  .inputValidator((data: unknown) => articlePathSchema.parse(data))
  .handler(async ({ data }) => {
    const { getArticleBySlug } = await import("./agora-queries.server");
    return getArticleBySlug(data.slug, data.legacyCategorySlug);
  });

export const fetchAgoraAuthors = createServerFn({ method: "GET" }).handler(async () => {
  const { listAuthors } = await import("./agora-queries.server");
  return listAuthors();
});

export const fetchAgoraAuthor = createServerFn({ method: "GET" })
  .inputValidator((data: unknown) => slugSchema.parse(data))
  .handler(async ({ data }) => {
    const { getAuthor, listPublishedArticles } = await import("./agora-queries.server");
    const author = await getAuthor(data);
    if (!author) return { author: null, articles: [] };
    const { articles } = await listPublishedArticles({ authorSlug: data, pageSize: 24 });
    return { author, articles };
  });

/** Ancien lien /contributeurs/<user_id> : renvoie le slug auteur public s'il existe. */
export const fetchAuthorSlugForUser = createServerFn({ method: "GET" })
  .inputValidator((data: unknown) => uuidSchema.parse(data))
  .handler(async ({ data }) => {
    const { getAuthorSlugForUser } = await import("./agora-queries.server");
    return getAuthorSlugForUser(data);
  });
